import React from 'react';
import { AffiliateHeader, AffiliateFooter } from '../components/affiliate/AffiliateChrome';
import { CONTACT_INFO } from '../data/branding';

const PrivacyPage = () => (
  <div className="min-h-screen bg-neutral-950 text-white">
    <AffiliateHeader />
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-invert prose-headings:font-display prose-headings:tracking-tight">
      <h1>Privacy Policy</h1>
      <p className="text-neutral-400">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
      <p>
        Axon Muscle (&ldquo;we&rdquo;, &ldquo;us&rdquo;) operates the Axon Muscle Affiliate Program at
        affiliate.axonmuscle.com. This page explains what information we collect when you apply to or use the program.
      </p>
      <h2>What we collect</h2>
      <ul>
        <li><strong>Application data:</strong> name, email, phone, country, traffic source, monthly traffic, payout method.</li>
        <li><strong>Account data:</strong> hashed password, login session token.</li>
        <li><strong>Performance data:</strong> clicks, conversions, and order amounts attributed to your affiliate link.</li>
      </ul>
      <h2>How we use it</h2>
      <p>To review your application, operate your affiliate account, attribute sales to your link, calculate commissions, and send you program updates.</p>
      <h2>Sharing</h2>
      <p>We do not sell your information. We share it only with payment processors and infrastructure providers strictly necessary to run the program.</p>
      <h2>Billing descriptor disclosure</h2>
      <p>By joining the program, you agree that transactions generated through your affiliate link may appear on customer billing statements with a billing descriptor unique to your affiliate account.</p>
      <h2>Contact</h2>
      <p>Questions? Email <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a> or call {CONTACT_INFO.phone}.</p>
    </article>
    <AffiliateFooter />
  </div>
);

export default PrivacyPage;
